export const prizePlanConstants = {
  LIST_PRIZE_REQUEST: 'LIST_PRIZE_REQUEST',
  LIST_PRIZE_SUCCESS: 'LIST_PRIZE_SUCCESS',
  LIST_PRIZE_FAILURE: 'LIST_PRIZE_FAILURE'
};
